import React, { useEffect, useState,useRef } from "react";
import { useNavigate, Link,useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useConfig } from "../config";
import "./Navbar.css";
import "./ErrorModal.css"; // Create this file for styling

// Add this state for error modal


function Navbar() {
  const { user, loading, logout } = useAuth();
  const { config, loading: configLoading } = useConfig();
  const [user_role, set_user_role] = useState("");
  const [assistants, setAssistants] = useState([]);
  const [showAssistantsMenu, setShowAssistantsMenu] = useState(false);
  const [selectedAssistant, setSelectedAssistant] = useState(localStorage.getItem("selected_assistant") || "");
  const location = useLocation();
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();


  const handleLogoClick = () => {
    navigate('/hr');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
        document.body.classList.remove("menu-open");
      }
  
      // Also close if iframe itself is clicked
      if (isMenuOpen && event.target.tagName === "IFRAME") {
        setIsMenuOpen(false);
        document.body.classList.remove("menu-open");
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);
  
  
  

  

  useEffect(() => {
    // const userId = localStorage.getItem("user_id");
    // const email = localStorage.getItem("email");
    set_user_role(localStorage.getItem("user_type"));
    const fetchUsers = async () => {
  //   const response = await fetch(`${config.API_BASE_URL}/api/admin/users/${userId}?email=${email}`);
  //   // For testing, don't redirect to login
  //   if (!response.ok) {
  //     const errorData = await response.json();
  //     //console.error("Error fetching users:", errorData);
  //     // Return empty array instead of throwing error
  //     return [];
  //   }

  //   const data = await response.json();
  //   //console.log("User data:", data);
  //   if (data.length > 0){
  //     set_user_role(localStorage.getItem("user_type"));
  //     if (data[0].user_type !== 'Admin' && location.pathname === '/admin'){
  //       navigate('/hr');
  //     }

  //   }
    
  //   return ;
  };
  fetchUsers();
  }, []);

  // Fetch assistants
  useEffect(() => {
    const fetchAssistants = async () => {
      try {
        
        const response = await fetch(`${config.API_BASE_URL}/api/assistants/get_all_assistants`);
        if (!response.ok) {
          throw new Error('Failed to fetch assistants');
        }
        const data = await response.json();
        const user_assistant_response = await fetch(`${config.API_BASE_URL}/api/assistants/get_all_user_assistants`);
        if (!user_assistant_response.ok) {
          throw new Error('Failed to fetch user assistants');
        }
        const user_assistant_data = await user_assistant_response.json();
        //console.log("User assistant data:", user_assistant_data);
        setAssistants(data || []);
        setShowAssistantsMenu(data.length > 1);

        setSelectedAssistant(user_assistant_data[0].selected_assistant);
        localStorage.setItem("selected_assistant", user_assistant_data[0].selected_assistant);
      } catch (error) {
        //console.error("Error fetching assistants:", error);
      }
    };
    fetchAssistants();
  }, []);



  const closeErrorModal = () => {
    setErrorModalVisible(false);
  };

  const handleLogout = async (email,user_id) => {
    await logout(email,user_id);
  };
  const isLoginPage = location.pathname === '/login';
  // Add this for debugging
  //console.log("Current user:", user);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    if (!isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };
  return (
    <nav className="navbar">
      {errorModalVisible && (
        <div className="error-modal-overlay">
          <div className="error-modal">
            <div className="error-modal-header">
              <h3>Error</h3>
              <button className="close-button" onClick={closeErrorModal}>×</button>
            </div>
            <div className="error-modal-body">
              <p>{errorMessage}</p>
            </div>
            <div className="error-modal-footer">
              <button onClick={closeErrorModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      <div className={`navbar-container ${isLoginPage ? 'login-page' : ''}`}>
        <div className="project-name-logo" onClick={handleLogoClick}>
          <Link to="/hr">
            {!configLoading && config.LOGO ? (
              <img
                src="/img/logo_toto.png"
                alt="Logo"
                className="project-name-logo-img"
              />
            ) : (
              <span className="project-name-logo-text"></span>
            )}
          </Link>
        </div>
        <div className="navbar-actions">
          {!isLoginPage && showAssistantsMenu && (
            <div className="assistants-menu">
              {/* <select
                className="assistants-select"
                value={assistants.find(ast => ast.selected_assistant === selectedAssistant)?.assistant_id || ""}
                onChange={(e) => handleAssistantChange(e.target.value)}
              >
                {assistants.map((assistant) => (
                  <option key={assistant.id} value={assistant.id}>
                    {assistant.name}
                  </option>
                ))}
              </select> */}
            </div>
          )}
          
          {user_role === 'Admin' && location.pathname !== '/admin' && (
            <a
              href="/admin"
              className="admin-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Admin
            </a>
          )}
          
          {!isLoginPage && (
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          )}
        </div>
        
        {/* Hamburger Menu Button */}
        <button className="hamburger-button" onClick={toggleMenu} aria-label="Open menu" ref={buttonRef}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`} ref={menuRef}>
          {/* Assistants menu */}
          {/* {!isLoginPage && showAssistantsMenu && assistants.length > 0 && (
            <div className="assistants-menu">
              <select
                className="assistants-select"
                value={selectedAssistant}
                onChange={(e) => handleAssistantChange(e.target.value)}
              >
                {assistants.map((assistant) => (
                  <option key={assistant.id} value={assistant.id}>
                    {assistant.name}
                  </option>
                ))}
              </select>
            </div>
          )} */}
          {/* Admin Button */}
          {user_role === 'Admin' && location.pathname !== '/admin' && (
            <a
              href="/admin"
              className="admin-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Admin
            </a>
          )}
          {/* Logout Button */}
          {!isLoginPage && (
            <button onClick={(e) =>
              handleLogout(
                localStorage.getItem("email"),
                localStorage.getItem("user_id"),

              )
            } className="logout-button">
              Logout
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
